import React, { useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import { AccountDetails } from 'pages/AccountDetails/AccountDetails';
import { MobileNumber } from 'pages/MobileNumber/MobileNumber';
import { Confirmation } from 'pages/Confirmation/Confirmation';

const basepath = window.location.pathname;

const validBasePaths = ['/cb', '/yb', '/vm'];
const defaultBasePath = '/vm';

export const getBasePath = () => {
  const path = validBasePaths.find((path) => basepath.toLowerCase().indexOf(path) === 0);
  if (path) return path;
  return defaultBasePath;
};

export const routes = [
  {
    path: `/`,
    exact: true,
    render: (props) => <AccountDetails {...props} />
  },
  {
    path: `/mobile-number`,
    exact: true,
    render: (props) => <MobileNumber {...props} />
  },
  {
    path: `/confirmation`,
    exact: true,
    render: (props) => <Confirmation {...props} />
  },
  {
    path: '/*',
    exact: false,
    render: () => <div>404</div>
  }
];

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const Router = () => (
  <Switch>
    <Route>
      <ScrollToTop />
      <Switch>
        {routes.map((route) => (
          <Route path={route.path} render={route.render} exact={route.exact} key={route.path} />
        ))}
      </Switch>
    </Route>
  </Switch>
);
